import { useState, useRef } from 'react';
import api from '../../api';
import stili from '../../components/competenze/stili';
import ConflittoVersione, { eConflitto } from '../../components/ConflittoVersione';
import AvvisoDatiComuni from '../../components/competenze/AvvisoDatiComuni';

// Nuova ditta o modifica (la stessa anagrafica dei clienti di Parcellazione)
export default function FormDitta({ ditta, ragioneIniziale = '', onChiudi, onSalvato }) {
  const daDitta = d => ({
    ragione_sociale: d?.ragione_sociale || ragioneIniziale,
    codice_fiscale: d?.codice_fiscale || '',
    codice_azienda: d?.codice_azienda ?? d?.codice_ditta_paghe ?? '',
    attivo: d ? d.attivo : true,
    version: d?.version,
  });
  const [form, setForm] = useState(daDitta(ditta));
  const collegata = Boolean(ditta?.anagrafica_id);   // dati comuni in sola lettura: si modificano in Anagrafiche
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);
  const occupato = useRef(false);   // doppio clic: lo stato React si aggiorna solo al ridisegno
  const [conflitto, setConflitto] = useState(null);

  const salva = async (version) => {
    setErrore('');
    if (occupato.current) return;
    occupato.current = true;
    setSalvataggio(true);
    try {
      const res = ditta ? await api.put(`/scadenze/ditte/${ditta.id}`, { ...form, version }) : await api.post('/scadenze/ditte', form);
      setConflitto(null);
      onSalvato(res.data);
    } catch (err) {
      if (eConflitto(err)) setConflitto(err.response.data);
      else if (err.response?.data?.codice === 'DATI_COMUNI_IN_ANAGRAFICHE') setErrore(`${err.response.data.errore} Chiudi e riapri il modulo per vedere i dati aggiornati.`);
      else setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      occupato.current = false; setSalvataggio(false);
    }
  };

  return (
    <div style={stili.overlay}>
      <div style={{ ...stili.modal, maxWidth: '520px' }}>
        <h3 style={{ marginTop: 0 }}>{ditta ? `Modifica ${ditta.ragione_sociale}` : 'Nuova azienda'}</h3>
        <form onSubmit={e => { e.preventDefault(); salva(form.version); }}>
          {errore && <div style={stili.errore}>{errore}</div>}
          {collegata && <AvvisoDatiComuni anagraficaId={ditta.anagrafica_id} onNavigare={onChiudi} />}
          <div style={stili.campo}>
            <label style={stili.label}>Ragione sociale</label>
            <input autoFocus={!collegata} disabled={collegata} value={form.ragione_sociale} onChange={e => setForm(f => ({ ...f, ragione_sociale: e.target.value }))} required style={stili.input} />
          </div>
          <div style={stili.row}>
            <div style={stili.campo}>
              <label style={stili.label}>Codice azienda (paghe e contabilità)</label>
              <input disabled={collegata} value={form.codice_azienda} maxLength={20} onChange={e => setForm(f => ({ ...f, codice_azienda: e.target.value }))} style={stili.input} placeholder="es. 299" />
            </div>
            <div style={stili.campo}>
              <label style={stili.label}>Codice fiscale / P.IVA</label>
              <input disabled={collegata} value={form.codice_fiscale} maxLength={16} onChange={e => setForm(f => ({ ...f, codice_fiscale: e.target.value }))} style={stili.input} />
            </div>
          </div>
          {ditta && (
            <label style={{ fontSize: '0.88rem', display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
              <input type="checkbox" checked={form.attivo} onChange={e => setForm(f => ({ ...f, attivo: e.target.checked }))} />
              Ditta seguita (se tolta, esce dai suggerimenti ma resta nello storico)
            </label>
          )}
          <div style={stili.azioni}>
            <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={stili.btn}>{salvataggio ? 'Salvataggio…' : 'Salva'}</button>
          </div>
        </form>
      </div>
      {conflitto && (
        <ConflittoVersione
          conflitto={conflitto}
          inCorso={salvataggio}
          onRicarica={() => { setForm(daDitta(conflitto.attuale)); setConflitto(null); }}
          onSovrascrivi={() => salva(conflitto.attuale.version)}
        />
      )}
    </div>
  );
}
